import { FORM_ERROR } from 'final-form'
import { defineComponent } from 'vue'

import { MovementTypes, ThesaurusTerm } from '@skinsoft/types'
import { TrackingRoutes } from '@skinsoft/const'
import { thesaurusTermSelectors } from '@skinsoft/selectors'
import { fetch } from '@skinsoft/network'
import { MovementDataStore } from '@skinsoft/entity'

import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { CreateMovementForm, Values } from './create-movement-form'

const MOTIVE_THESAURUS_ID = '5afe82242ab7912341617924'

export const CreateMovementModal = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sCreateMovementForm: CreateMovementForm,
    },
    template: require('./create-movement-modal.html'),
    data() {
        return {
            canBeClosed: false,
            initialValues: {
                motive: null as any,
                title: null as any,
            } as Values,
            motives: null as unknown as ThesaurusTerm[],
            mounted: false,
            thesaurusSelectors: thesaurusTermSelectors,
            movementType: undefined as MovementTypes | undefined,
            // $movementDataStore / $thesaurusTermDataStore are Vue.prototype globals installed by
            // their respective data stores, not per-instance state
        }
    },
    methods: {
        open(movementType: MovementTypes) {
            this.movementType = movementType;
            (this.$refs.modal as any).show();
        },
        onHide() {
            this.canBeClosed = false;
            this.mounted = false;
        },
        onShow() {
            this.mounted = true;
        },
        subscribeToMotiveThesaurus() {
            this.subscribeTo(
                (this as any).$thesaurusTermDataStore.fetchRoot(MOTIVE_THESAURUS_ID),
                thesaurusTerms => {
                    this.motives = thesaurusTerms;
                },
                'motiveThesaurus',
            );
        },
        async onSubmit(values) {
            try {
                const { id } = await ((this as any).$movementDataStore as MovementDataStore).createMovement(
                    // movementType is always COMPLEX or SIMPLE here: open() (always called before the
                    // form can submit) only ever passes one of those two values.
                    this.movementType as MovementTypes.COMPLEX | MovementTypes.SIMPLE,
                    undefined,
                    values.title,
                    values.motive,
                );

                const params: Record<string, string> = { id };
                (this.$refs.modal as any).hide();
                return this.$router.push({
                    name: TrackingRoutes.MOVEMENT,
                    params,
                });
            } catch (error) {
                return {
                    [FORM_ERROR]: fetch.isNetworkError(error as Error)
                        ? 'entity.createModal.error.network'
                        : 'entity.createModal.error.api',
                };
            }
        },
    },
    watch: {
        mounted(value) {
            this.$emit('mounted', value);
            if (value) {
                this.unsubscribeFrom('motiveThesaurus');
                this.subscribeToMotiveThesaurus();
            }
        },
    },
})
